export const BUYER_ERROR_META_DATA_KEYS = {
  IIN: 'identity.iin',
};
